import React from "react";
import PropTypes from "prop-types";

function Searchbar({value, placeholder, loading, onChange, onSubmit}) {
    return (
        <div className="search-form mb-8">
            <div className="input-section">
                <div className="input-group input-group--inline">
                    <input
                        type="text"
                        className="form-control"
                        placeholder={placeholder}
                        value={value}
                        onChange={onChange}
                    />
                    <div className="input-group-append">
                        <button
                            className="btn btn-secondary"
                            style={{width: 50, fontSize: 20}}
                            onClick={onSubmit}
                        >
                            <i className={loading ? "fa fa-spinner fa-spin" : "fa fa-search"}></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

Searchbar.propTypes = {
    value: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
}

export default Searchbar;